import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';
import { motion } from 'framer-motion';

export default function Thinking() {
  return (
    <SectionWrapper id="thinking" className="py-20 text-center">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-4xl font-semibold text-white mb-8"
      >
        Things I'm Thinking About Lately
      </motion.h2>

      <motion.ul
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="max-w-2xl mx-auto space-y-6 text-slate-300 text-lg md:text-xl font-inter px-4"
      >
        <li>
          🧠 <span className="text-white font-medium">Neural network sparsity</span> — What if we didn’t need more, just better routing?
        </li>
        <li>
          🦇 <span className="text-white font-medium">What Batman would automate</span> if he were a backend dev with AWS credits.
        </li>
        <li>
          📊 <span className="text-white font-medium">Compounding, not effort</span> — how infra + habits scale intelligence.
        </li>
        <li>
          🔍 <span className="text-white font-medium">What makes an engineer memorable</span> beyond shipping — clarity? taste? code poetry?
        </li>
      </motion.ul>
    </SectionWrapper>
  );
}
